import * as actions from '../actions/GlobalActions';

const getLocalStorageUser = () => {
  try {
    let user = JSON.parse(localStorage.getItem('user'));
    return user;
  } catch {
    return null
  }
};

const initialState = {
  successToastOpen: false,
  errorToastOpen: false,
  successMessage: '',
  errorMessage: '',
  showLoadingDiv: false,
  logged: Boolean(localStorage.getItem('auth')),
  loggedUser: getLocalStorageUser(),
  refreshDataSets: 0,
  currentRegistrationStep: 0,
  invitation: null,
  registrationInfo: { password: '' },
  currentPasswordResetStep: 0,
  passwordResetToken: null,
};

const GlobalReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.EDIT_PROFILE: {
      return { ...state, loggedUser: action.payload };
    }
    case actions.LOGIN: {
      localStorage.setItem('auth', action.payload.auth);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      return { ...state, logged: true, loggedUser: action.payload.user };
    }
    case actions.LOGOUT: {
      return { ...state, logged: false, loggedUser: null };
    }
    case actions.SHOW_LOADING_DIV: {
      return { ...state, showLoadingDiv: true };
    }
    case actions.HIDE_LOADING_DIV: {
      return { ...state, showLoadingDiv: false };
    }
    case actions.SHOW_SUCCESS_TOAST:
      return {
        ...state,
        successToastOpen: true,
        successMessage: action.msg,
      };
    case actions.HIDE_SUCCESS_TOAST:
      return {
        ...state,
        successToastOpen: false,
      };
    case actions.SHOW_ERROR_TOAST:
      return {
        ...state,
        errorToastOpen: true,
        errorMessage: action.msg,
      };
    case actions.HIDE_ERROR_TOAST:
      return {
        ...state,
        errorToastOpen: false,
      };
    case actions.REFRESH_DATA_SETS:
      return {
        ...state,
        refreshDataSets: state.refreshDataSets + 1,
      };
    case actions.OPEN_INVITATION:
      return {
        ...state,
        invitation: action.payload,
      };
    case actions.NEXT_REGISTRATION_STEP:
      const stepIncrement = state.invitation.role === 'LEGAL_TEAM' ? 2 : 1;
      return {
        ...state,
        currentRegistrationStep: state.currentRegistrationStep + stepIncrement,
      };
    case actions.PREVIOUS_REGISTRATION_STEP:
      const stepDecrement = state.invitation.role === 'LEGAL_TEAM' ? 2 : 1;
      return {
        ...state,
        currentRegistrationStep: state.currentRegistrationStep - stepDecrement,
      };
    case actions.FINISH_REGISTRATION:
      return {
        ...state,
        currentRegistrationStep: 4,
      };
    case actions.INVALID_INVITATION:
      return {
        ...state,
        currentRegistrationStep: 5,
      };
    case actions.FINISH_REGISTRATION_LEGAL_TEAM:
      return {
        ...state,
        currentRegistrationStep: 6,
      };
    case actions.ENTER_PHONE:
      return {
        ...state,
        registrationInfo: { ...state.registrationInfo, phone: action.payload },
      };
    case actions.CHOOSE_PASSWORD:
      return {
        ...state,
        registrationInfo: { ...state.registrationInfo, password: action.payload },
      };
    case actions.ACCEPT_LEGAL_TERMS:
      return {
        ...state,
        registrationInfo: { ...state.registrationInfo, legalAggreements: action.payload },
      };

    case actions.INVALID_PASSWORD_RESET_TOKEN:
      return {
        ...state,
        currentPasswordResetStep: 1,
      };
    case actions.SET_PASSWORD_RESET_TOKEN:
      return {
        ...state,
        passwordResetToken: action.payload,
      };
    case actions.PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        currentPasswordResetStep: 2,
      };

    case actions.PASSWORD_RESET_CANCELLED:
      return {
        ...state,
        currentPasswordResetStep: 3,
      };

    default:
      return state;
  }
};

export default GlobalReducer;
